import { render } from "./index.vue?vue&type=template&id=df8ac5ec&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-df8ac5ec"

export default script